import React from 'react';

export const Sereignasparnadur = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 64 64"
      height="64"
      width="64"
    >
      <g data-name="icon/forsíða/séreignasparnaður">
        <g data-name="icon/Lífeyrir">
          <g
            stroke="#20446a"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
            data-name="Group"
          >
            <path
              fill="#cef2f8"
              fillRule="evenodd"
              d="M33.892 34.208s-7.079-12.534 6.6-17.32c.001 0 9.447 12.826-6.6 17.32z"
              data-name="Stroke-4"
            ></path>
            <path
              fill="#cef2f8"
              fillRule="evenodd"
              d="M31.7 40.978s-3.363-9.791-14.261-6.992c0 0 1.561 12.366 14.261 6.992z"
              data-name="Stroke-6"
            ></path>
            <path
              fill="none"
              d="M33.634 34.084s-4.6 9.178 1.75 13.4"
              data-name="Stroke-8"
            ></path>
            <path
              fill="none"
              d="M32.281 38.3s2.414-9.977-4.72-12.663"
              data-name="Stroke-8-Copy"
            ></path>
            <path
              fill="none"
              d="M44.308 47.546c-6.616-2.408-12.474-.163-15.095 7.039"
              data-name="Path-Copy"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Sereignasparnadur;
